import React from "react";
import "./forgetpassword.scss";
import { images } from "../../utils/customFn";
import useForgetPasswordUtils from "./useForgetPasswordUtils";
import { Link } from "react-router-dom";
import OverlayLoading from "../../common/OverlayLoader/Overlayloader";

const ForgetPassword = () => {
  const {
    formData,
    formErrors,
    loading,
    handleChange,
    handleSubmit,
  } = useForgetPasswordUtils();



  console.log("formErrors",formErrors)

  return (
    <div className="login_main_page">
  
      <div className="page_side_pd">
        <div className="page_flex_data">
          <div className="page_form_data">
            <div className="form-inner-data">
              <div className="logo_container">
                <img src={images["side_logo.png"]} alt="" className="logo" />
              </div>
              <div className="page_heading"></div>
              <form onSubmit={handleSubmit}>
                <div className="all_input">
                  <label>Email</label>
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email"
                  />
                  {formErrors.email && (
                    <small className="error-message text-danger">
                      {formErrors.email}
                    </small>
                  )}
                </div>

                

                <div className="btn_main_login">
                  <button
                    type="submit"
                    className="btn-comman-main"
                    disabled={loading}
                  >
                    {loading ? "Sending mail...." : "Send Mail"}
                  </button>
                </div>
                 <div className="text-right forget_password_btn mt-4 text-center" >
                    <Link to={'/'}  >Back to Login  </Link>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
